// @ts-nocheck
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import '@/styles/vf-tokens.css'
import '@/i18n'
import { installClientErrorReporter } from '@/lib/clientErrorReporter'

// Browser storage left by removed code: the unused settings store (its
// language default could disagree with the saved one). Harmless to repeat.
try { localStorage.removeItem('settingsStore'); } catch { /* storage unavailable */ }
// Thèmes du prototype retirés (W1) : DESIGN.md est la seule source.
try { localStorage.removeItem('revcall.theme'); } catch { /* storage unavailable */ }

// SU-5 (W7): uncaught errors to the super admin's « Erreurs client » (never in tests).
installClientErrorReporter();

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>,
)

if (import.meta.hot) {
  import.meta.hot.on('vite:beforeUpdate', () => {
    window.parent?.postMessage({ type: 'sandbox:beforeUpdate' }, '*');
  });
  import.meta.hot.on('vite:afterUpdate', () => {
    window.parent?.postMessage({ type: 'sandbox:afterUpdate' }, '*');
  });
}
